import html2canvas, { Options } from 'html2canvas'

export const convertToImage = async (
  element: HTMLDivElement,
  boundingBox: DOMRect
) => {
  const options: Partial<Options> = {
    allowTaint: true,
    useCORS: true,
    width: boundingBox.width,
    height: boundingBox.height,
  }

  const canvas = await html2canvas(element, options)

  return (await new Promise(resolve => {
    canvas.toBlob(async blob => {
      resolve(blob)
    })
  })) as Blob | null
}
